import {createSlice} from '@reduxjs/toolkit';


export const ApprovalReducer = createSlice({
    name:'approval',
    initialState:{role:{},approvalConfig:[]},
    reducers:{
        setRole: (state,action)=>{
            return {
                ...state, role: action.payload
            }
        },
        setApprovalConfig:(state:any,action) =>{
          
            return {
                ...state,approvalConfig:action.payload
            }
        },
        addApprovalConfig:(state:any,action) =>{
            let newConfig = [action.payload,...state.approvalConfig]
            return {
                ...state,approvalConfig:newConfig
            }
        }
       
    }


})

export const {setRole,addApprovalConfig,setApprovalConfig} = ApprovalReducer.actions;
export default ApprovalReducer.reducer;